module.exports = __webpack_public_path__ + "static/img/04.ec2ee5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/mz_brunegg/04.jpg
// module id = 426
// module chunks = 1